import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/dialog';
import { Label } from '@shadcn/components/label';
import { Switch } from '@shadcn/components/switch';

export interface WordMatSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  showColors: boolean;
  onShowColorsChange: (value: boolean) => void;
  alphabetColorCode: boolean;
  onAlphabetColorCodeChange: (value: boolean) => void;
  tileSwapEnabled: boolean;
  onTileSwapEnabledChange: (value: boolean) => void;
  interactionMode: 'mat' | 'stack';
  onInteractionModeChange: (value: 'mat' | 'stack') => void;
}

export default function WordMatSettingsDialog({
  open,
  onOpenChange,
  showColors,
  onShowColorsChange,
  alphabetColorCode,
  onAlphabetColorCodeChange,
}: WordMatSettingsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Word Mat Settings</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-6 py-4">
          {/* Visual Settings Section */}
          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
              Visual Settings
            </h3>
            <div className="flex items-center justify-between">
              <Label htmlFor="color-toggle" className="text-sm text-gray-600">
                Color-coding
              </Label>
              <Switch
                id="color-toggle"
                checked={showColors}
                onCheckedChange={onShowColorsChange}
              />
            </div>
            <div className="flex items-center justify-between">
              <Label
                htmlFor="alphabet-color-toggle"
                className="text-sm text-gray-600"
              >
                Color-code alphabet (vowels & consonants)
              </Label>
              <Switch
                id="alphabet-color-toggle"
                checked={alphabetColorCode}
                onCheckedChange={onAlphabetColorCodeChange}
              />
            </div>
          </div>

          {/* <Separator /> */}

          {/* Interaction Mode Section */}
          {/* <div className="flex flex-col gap-4">
            <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
              Interaction Mode
            </h3>
            <div className="flex flex-col gap-3">
              <Label
                className={cn(
                  'flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-colors',
                  interactionMode === 'mat'
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 hover:border-gray-300',
                )}
              >
                <input
                  type="radio"
                  name="interaction-mode"
                  value="mat"
                  checked={interactionMode === 'mat'}
                  onChange={() => onInteractionModeChange('mat')}
                  className="mt-1"
                />
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-gray-700">
                    Word Mat
                  </span>
                  <span className="text-xs text-gray-500">
                    Tiles rearrange when dragging (default behavior)
                  </span>
                </div>
              </Label>
              <Label
                className={cn(
                  'flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-colors',
                  interactionMode === 'stack'
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 hover:border-gray-300',
                )}
              >
                <input
                  type="radio"
                  name="interaction-mode"
                  value="stack"
                  checked={interactionMode === 'stack'}
                  onChange={() => onInteractionModeChange('stack')}
                  className="mt-1"
                />
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-gray-700">
                    Word Stack
                  </span>
                  <span className="text-xs text-gray-500">
                    Tiles can stack on top of each other without rearranging
                  </span>
                </div>
              </Label>
            </div>
          </div> */}
        </div>
      </DialogContent>
    </Dialog>
  );
}
